/** Families type "3" or "Field 3" into the same box. Adds "Field " only when it is missing. */
export function fieldLabel(field: string | null | undefined): string | null {
  const f = (field || '').trim();
  if (!f) return null;
  return /^field\b/i.test(f) ? f : `Field ${f}`;
}
